import axios from "axios";
import { decodeJWT } from "../utils/JWT_decode";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const get = (url: string) => instance.get(url);
export const post = (url: string, data: any) => instance.post(url, data);
export const put = (url: string, data: any) => instance.put(url, data);
export const del = (url: string) => instance.delete(url);
export const patch = (url: string, data: any) => instance.patch(url, data);

export const getJWT = () =>
  localStorage.getItem("token")
    ? decodeJWT(localStorage.getItem("token") ?? "")
    : null;

export default instance;
